module.exports = __webpack_public_path__ + "static/media/home-banner-mobile.4da52025.jpg";